<h4 style="padding: 30px 20px;">{{data.msg}}</h4>
<mat-card *ngIf="data.deviceType==6">
    <mat-card-subtitle>	
        Follow the below steps to resolve Utility Error concern
    </mat-card-subtitle>
    <mat-card-content style="text-align: left;">
        <div>
            <strong>Step 1.</strong>Open Chrome browser in your laptop/desktop and type chrome://flags/#allow-insecure-localhost
            <img src="../../../assets/images/AEPS_browser_settings.png" alt="">
        </div>
      <div>
        <strong>Step 2.</strong>Click on Enabled to Allow invalid certificates for resources loaded from local host and then click on RELAUNCH NOW button.
        <img src="../../../assets/images/aeps_chrome-setting2.png" alt="">
      </div>
    <div>
        <strong>Step 3.</strong>
        Download file and click on folder to open "restart_svcs.bat file". To download <a href="https://images.vartulz.com/mantra-startup.zip">Click here.</a> 
       <img src="../../../assets/images/download_unzip.png" alt="">  
    </div>
       <div>
        <strong>Step 4.</strong>
        Run the file restart_svcs.bat file by double clicking this will open command prompt window once the window is closed login to EasyRin website and start doing AePs transaction
       </div>
      <div>
        <strong>Step 5.</strong>
        In Case the below error "MFS100 started or already stopped " comes, restart your laptop/desktop and follow the above mentioned steps again. 
      <img src="../../../assets/images/mfs100.jpg" alt="">
      </div>
        <div>
            <strong> For any other assistance, reach our support team from the Contact For any other assistance, reach our support team from the Contact us page. nbsp;us page. </strong>
        </div>
        </mat-card-content>
</mat-card>




<mat-card *ngIf="data.deviceType==1">
  <mat-card-subtitle>	
      Follow the below steps to resolve Utility Error concern
  </mat-card-subtitle>
  <mat-card-content>
      <div>
          <strong>Step 1.</strong>Open Chrome browser in your laptop/desktop and type chrome://flags/#allow-insecure-localhost
          <img src="../../../assets/images/AEPS_browser_settings.png" alt="">
      </div>
    <div>
      <strong>Step 2.</strong>Click on Enabled to Allow invalid certificates for resources loaded from local host and then click on RELAUNCH NOW button.
      <img src="../../../assets/images/aeps_chrome-setting2.png" alt="">
    </div>
  <div>
      <strong>Step 3.</strong>
      Follow all the steps of this PDF file <a target="_blank" href="https://images.vartulz.com/morpho.pdf">Click here.</a>     
  </div>
    
    
      <div>
          <strong> For any other assistance, reach our support team from the Contact For any other assistance, reach our support team from the Contact us page. nbsp;us page. </strong>
      </div>
      </mat-card-content>
</mat-card>

<mat-card *ngIf="data.deviceType==3">
  <mat-card-subtitle>	
      Follow the below steps to resolve Utility Error concern
  </mat-card-subtitle>
  <mat-card-content>
      <div>
          <strong>Step 1.</strong>Open Chrome browser in your laptop/desktop and type chrome://flags/#allow-insecure-localhost
          <img src="../../../assets/images/AEPS_browser_settings.png" alt="">
      </div>
    <div>
      <strong>Step 2.</strong>Click on Enabled to Allow invalid certificates for resources loaded from local host and then click on RELAUNCH NOW button.
      <img src="../../../assets/images/aeps_chrome-setting2.png" alt="">
    </div>
  <div>
      <strong>Step 3.</strong>
      Follow all the steps of this PDF file <a target="_blank" href="https://mpvanmitra.mkcl.org/hi/faqs/user-guide/Startek_FM220_Biometric_Installation_Guide.pdf">Click here.</a>     
  </div>
    
    
      <div>
          <strong> For any other assistance, reach our support team from the Contact For any other assistance, reach our support team from the Contact us page. nbsp;us page. </strong>
      </div>
      </mat-card-content>
</mat-card>
<mat-card *ngIf="data.deviceType=='aratek'">
  <mat-card-subtitle>	
      Follow the below steps to resolve Utility Error concern
  </mat-card-subtitle>
  <mat-card-content>
      <div>
          <strong>Step 1.</strong>Open Chrome browser in your laptop/desktop and type chrome://flags/#allow-insecure-localhost
          <img src="../../../assets/images/AEPS_browser_settings.png" alt="">
      </div>
    <div>
      <strong>Step 2.</strong>Click on Enabled to Allow invalid certificates for resources loaded from local host and then click on RELAUNCH NOW button.
      <img src="../../../assets/images/aeps_chrome-setting2.png" alt="">
    </div>
  <div>
      <strong>Step 3.</strong>
      Install all the files from this link and follow the steps of NOTE.txt <a target="_blank" href="https://drive.google.com/file/d/1lKJKedZRu2yJ3lDgxDdW_8nA7V9VQjz1/view?usp=sharing">Click here.</a>     
  </div>
    
    
      <div>
          <strong> For any other assistance, reach our support team from the Contact For any other assistance, reach our support team from the Contact us page. nbsp;us page. </strong>
      </div>
      </mat-card-content>
</mat-card>
<div mat-dialog-actions class="action-btn">
    <button type="button" class="er-btn er-btn--primary" [mat-dialog-close]="data.animal" cdkFocusInitial>Okay</button>
  </div>